import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import styled from "styled-components";
import { Text, TextColor, TextSize, TextVariant, TextWeight } from "../../../components";
import { ProductListItem } from "../../ProductListItem";
export const OrderSection = t0 => {
  const $ = _c(23);
  const {
    cartQuantity,
    products
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  if ($[0] !== isOpen) {
    t1 = () => setIsOpen(!isOpen);
    $[0] = isOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Text text={"Zam\xF3wienie"} variant={TextVariant.H6} weight={TextWeight.SEMIBOLD} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `${cartQuantity} szt.`;
  let t4;
  if ($[3] !== t3) {
    t4 = <Text text={t3} fontSize={TextSize.S} color={TextColor.GRAYSCALE_500} />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = `w-5 h-5 text-gray-500 transform transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t5) {
    t7 = <svg className={t5} fill="none" stroke="currentColor" viewBox="0 0 24 24">{t6}</svg>;
    $[6] = t5;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t4 || $[9] !== t7) {
    t8 = <div className="flex items-center justify-between">{t2}<div className="flex items-center gap-2">{t4}{t7}</div></div>;
    $[8] = t4;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== isOpen || $[12] !== t1 || $[13] !== t8) {
    t9 = <button className="w-full duration-200 text-left" onClick={t1} aria-expanded={isOpen} aria-controls="order-products">{t8}</button>;
    $[11] = isOpen;
    $[12] = t1;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const t10 = `flex flex-col gap-4 my-4 w-full transition-all duration-300 ease-in-out ${isOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"} overflow-hidden overflow-y-auto`;
  let t11;
  if ($[15] !== products) {
    t11 = products.map(_temp);
    $[15] = products;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t10 || $[18] !== t11) {
    t12 = <OrderSectionProducts className={t10}>{t11}</OrderSectionProducts>;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12 || $[21] !== t9) {
    t13 = <div className="mt-8">{t9}{t12}</div>;
    $[20] = t12;
    $[21] = t9;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
};
export const OrderSectionProducts = styled.div`
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 2px !important;
  }

  &::-webkit-scrollbar-track {
    background: ${({
  theme
}) => theme.colors.GRAYSCALE_100};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({
  theme
}) => theme.colors.GRAYSCALE_100};
    border-radius: 4px;

    &:hover {
      background: ${({
  theme
}) => theme.colors.GRAYSCALE_500};
    }
  }

  &::-webkit-scrollbar-thumb:active {
    background: ${({
  theme
}) => theme.colors.GRAYSCALE_100};
  }

  scrollbar-width: thin;
  scrollbar-color: ${({
  theme
}) => theme.colors.GRAYSCALE_300}
    ${({
  theme
}) => theme.colors.GRAYSCALE_100};
`;
function _temp(product) {
  return <ProductListItem key={product.idProduct || product.reference} product={product} simplified={true} />;
}